/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Container = styled.div({
  color: token('color.text.inverse'),
  padding: `${gridSize() * 2}px ${gridSize() * 3}px`,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
});

export const PanelButton = styled(Button)({
  '&:hover, &:focus': {
    backgroundColor: token('color.background.neutral.hovered'),
  },
});

export const Header = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: `${gridSize()}px`,
});

export const HeaderHeading = styled.h2({
  color: token('color.text.inverse'),
});

export const LoadingState = styled.section({
  margin: `${gridSize() * 4}px auto`,
});

export const TableSection = styled.section({
  marginTop: `${gridSize() * 4}px`,
});

// h500/h4 font-weight is inconsistent with typography library
// https://ecosystem.atlassian.net/jira/servicedesk/projects/DS/queues/issue/DS-7031
export const TableHeading = styled.h4({
  fontWeight: token('font.weight.medium'),
  color: token('color.text.inverse'),
  marginBottom: `${gridSize()}px`,
});

export const TableRow = styled.div({
  display: 'flex',
  '& > *': {
    flex: 1,
  },
});

export const TableRowKey = styled.b({
  color: token('color.text'),
});

export const DescriptionHeader = styled.div({
  alignItems: 'baseline',
  display: 'flex',
  marginBottom: `${gridSize()}px`,
});
